import {
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { Modal, Row, Col } from "react-bootstrap";
import { AiFillDelete, AiFillEdit } from "react-icons/ai";
import { AxiosError } from "axios";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useSelectAccess } from "../../../store/stateFunctions";
import useQuickLook from "../../../quicklook/useQuickLook";
import { server } from "../../../common";
const initialValues = {
  business_name: "",
  owner: "",
  mobile: "",
  email: "",
  details: "",
  address: "",
  landmark: "",
  city: "",
  pincode: "",
  location: "",
  url1: "",
  image: null,
};

const swalalert = withReactContent(Swal);

const AddOrganizationDetails = ({ role }) => {
  const user = useSelectAccess("Super Admin");
  const displayFile = useQuickLook();

  const [show, setShow] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setIsEditMode(false);
    setSelectedData(null);
    formik.setValues(initialValues);
    setShow(true);
  };

  const [data, setData] = useState([]);
  const [selectedData, setSelectedData] = useState(null);

  const handleShowGallery = (data) => {
    setSelectedData(data);
    setIsEditMode(true);
    setShow(true);
  };

  useEffect(() => {
    getData();
    // Check if in edit mode and selectedData is available
    if (isEditMode && selectedData) {
      formik.setValues({
        business_name: selectedData.business_name,
        owner: selectedData.owner,
        mobile: selectedData.mobile,
        email: selectedData.email,
        details: selectedData.details,
        address: selectedData.address,
        city: selectedData.city,
        landmark: selectedData.landmark,
        pincode: selectedData.pincode,
        location: selectedData.location,
        url1: selectedData.url1,
      });
    }
  }, [isEditMode, selectedData]);

  //   // Get
  const getData = () => {
    server
      .get("/adminorganization/getallorg_details", {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  // Delete gallery
  const handleDelete = (data) => {
    swalalert
      .fire({
        title: "Delete Confirmation!",
        text: `Are You Sure That You Want To Delete ${data.title} ?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        confirmButtonClass: "btn btn-success",
        cancelButtonClass: "btn btn-danger",
        buttonsStyling: true,
      })
      .then(function (swalObject) {
        if (swalObject.isConfirmed) {
          server
            .delete(`/adminorganization/deleteorg_details/${data.id}`, {
              headers: {
                "Content-Type": "application/json",
                Authorization: user.authToken,
              },
            })
            .then(function (response) {
              console.log("api response", response.data);
              if (response.status === 200 || response.status === 201) {
                swalalert.fire(
                  "Deleted!",
                  "Business has been deleted.",
                  "success"
                );
                getData();
              }
            })
            .catch((error) => {
              toast.error(error.response.data.message);
            });
        } else {
          swalalert.fire(
            "Cancelled",
            "Your imaginary file is safe :)",
            "error"
          );
        }
        //success method
      });
  };

  // update news
  const handleUpdate = (values) => {
    const formData = new FormData();
    formData.append("business_name", values.business_name);
    formData.append("owner", values.owner);
    formData.append("mobile", values.mobile);
    formData.append("email", values.email);
    formData.append("details", values.details);
    formData.append("address", values.address);
    formData.append("landmark", values.landmark);
    formData.append("city", values.city);
    formData.append("pincode", values.pincode);
    formData.append("location", values.location);
    formData.append("url1", values.url1);

    if (values.image) {
      formData.append("image", values.image);
    }

    server
      .put(`/adminmerchant/updatemerchantdetails/${values.id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        formik.resetForm();
        getData();
        toast.success("Details Updated successfully");
        handleClose();
      })
      .catch(function (error) {
        if (error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  // add
  const formik = useFormik({
    initialValues: isEditMode ? selectedData : initialValues,
    validationSchema: Yup.object({
      business_name: Yup.string().required("Enter a Shop/Business Name"),
      owner: Yup.string().required("Enter a Owner Name"),
      mobile: Yup.string().required("Enter a Mobile Number"),
      email: Yup.string().required("Enter a Email Id"),
      details: Yup.string().required("Enter a Business Details"),
      address: Yup.string().required("Enter a Business Address"),
      landmark: Yup.string().required("Enter a landmark"),
      city: Yup.string().required("Enter a City"),
      pincode: Yup.string().required("Enter a Pincode"),
      location: Yup.string().required("Enter a Google Location Link"),
      url1: Yup.string().required("Enter a Website Link"),

      image: Yup.mixed()
        .required("Please select an image")
        .test("fileSize", "File size is too large", (value) => {
          // Check the file size (if required)
          // Modify the limit according to your requirements
          return value ? value.size <= 5000000 : true;
        }),
    }),
    onSubmit: (values, action) => {
      if (isEditMode) {
        handleUpdate({ ...values, id: selectedData.id });
      } else {
        if (!values.image) {
          toast.error("Please select a images");
          return;
        }
        const formData = new FormData();
        formData.append("business_name", values.business_name);
        formData.append("owner", values.owner);
        formData.append("mobile", values.mobile);
        formData.append("email", values.email);
        formData.append("details", values.details);
        formData.append("address", values.address);
        formData.append("landmark", values.landmark);
        formData.append("city", values.city);
        formData.append("pincode", values.pincode);
        formData.append("location", values.location);
        formData.append("url1", values.url1);

        formData.append("image", values.image);

        server
          .post("/adminorganization/addorganizationdetails", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: user.authToken,
            },
          })
          .then(function (response) {
            if (response.status === 200 || response.status === 201) {
              toast.success("Business Added successfully");
              formik.resetForm();
              handleClose();
              getData();
            }
          })
          .catch(function (error) {
            if (error.response?.data?.message)
              toast.error(error.response.data.message);
            else if (error.response?.data?.error) {
              toast.error(error.response.data.error);
            } else toast.error("Failed to connect to server");
          });
      }
    },
  });

  // search
  const SearchData = (searchValue) => {
    server
      .get(`/blogs/searchind_blogs?search=${searchValue}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  return (
    <>
      <div className="container">
        <div className="row my-3">
          <div className="col-md-4">
            <input
              type="search"
              className="form-control"
              placeholder="Search Event"
              onChange={(e) => SearchData(e.target.value)}
            />
          </div>
          <div className="col-md-4"></div>
          <div className="col-md-4">
            <select className="form-control" name="" id="">
              <option value="">Latest</option>
              <option value="">Last Month</option>
              <option value="">Last Year</option>
            </select>
          </div>
        </div>
        <div className="d-flex position-relative mb-3 justify-content-center ">
          <h5 className="m-auto text-center">Previous Organizations</h5>
          <Button variant="contained" color="info" onClick={handleShow}>
            Add Organization
          </Button>

          <Modal show={show} onHide={handleClose} size="xl">
            <Modal.Header closeButton>
              <Modal.Title>
                {isEditMode ? "Edit Organization" : "Add Organization"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form
                className="needs-validation d-flex flex-column gap-2"
                onSubmit={formik.handleSubmit}
              >
                <div className="">
                  <h5 className="mb-3">Business Details</h5>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <TextField
                        name="business_name"
                        //   margin="dense"
                        type="text"
                        value={formik.values.business_name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        placeholder="Shop Name"
                        variant="outlined"
                        label="Business Name"
                        fullWidth
                        required
                      ></TextField>
                      <p className="text-danger">
                        {formik.errors.business_name}
                      </p>
                    </div>

                    <div className="col-md-6  mb-3">
                      <TextField
                        name="owner"
                        //   margin="dense"
                        type="text"
                        value={formik.values.owner}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        placeholder="Owner's Full Name"
                        variant="outlined"
                        label="Owner"
                        fullWidth
                        required
                      ></TextField>
                      <p className="text-danger">{formik.errors.owner}</p>
                    </div>
                  </div>
                  <div className="row  mb-3">
                    <div className="col-md-6">
                      <TextField
                        name="mobile"
                        //   margin="dense"
                        type="number"
                        value={formik.values.mobile}
                        onChange={formik.handleChange}
                        // disabled={!!props.edit}
                        onBlur={formik.handleBlur}
                        placeholder="Mobile Number"
                        variant="outlined"
                        label="Business Mobile Number"
                        fullWidth
                        required
                      ></TextField>
                      <p className="text-danger">{formik.errors.mobile}</p>
                    </div>

                    <div className="col-md-6">
                      <TextField
                        name="email"
                        //   margin="dense"
                        type="email"
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        placeholder="Business Email"
                        variant="outlined"
                        label="Business Email"
                        fullWidth
                        required
                      ></TextField>
                      <p className="text-danger">{formik.errors.email}</p>
                    </div>
                  </div>
                  <div className=" mb-3">
                    <TextField
                      name="details"
                      // margin="dense"
                      type="text"
                      value={formik.values.details}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      placeholder="Describe your business (min 200 chars)"
                      variant="outlined"
                      label="Business Details"
                      fullWidth
                      multiline
                      minRows={3}
                      required
                    ></TextField>
                    <p className="text-danger">{formik.errors.details}</p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 d-flex gap-3 align-items-center mb-2">
                    <label htmlFor="image data-name">
                      Organization/Institute Photos
                    </label>
                    <input
                      name="image"
                      type="file"
                      onChange={(event) => {
                        formik.setFieldValue(
                          "image",
                          event.currentTarget.files[0]
                        );
                      }}
                      // accept=".jpg,.png,.jpeg"
                    />
                    <p className="text-danger">{formik.errors.image}</p>
                  </div>
                </div>
                <div>
                  <h5 className="mb-3">Address Details</h5>
                  <div>
                    <div className="row  mb-3">
                      <div className="col-md-6">
                        <TextField
                          name="address"
                          type="text"
                          //   margin="dense"
                          value={formik.values.address}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          placeholder="Address"
                          variant="outlined"
                          label="Address"
                          fullWidth
                          required
                        ></TextField>
                        <p className="text-danger">{formik.errors.address}</p>
                      </div>
                      <div className="col-md-6">
                        <TextField
                          name="landmark"
                          type="text"
                          //   margin="dense"
                          value={formik.values.landmark}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          placeholder="Near Natraj Society"
                          variant="outlined"
                          label="Landmark"
                          fullWidth
                          required
                        ></TextField>
                        <p className="text-danger">{formik.errors.landmark}</p>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <TextField
                          name="city"
                          type="text"
                          //   margin="dense"
                          value={formik.values.city}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          placeholder="City"
                          variant="outlined"
                          label="City"
                          fullWidth
                          required
                        ></TextField>
                        <p className="text-danger">{formik.errors.city}</p>
                      </div>
                      <div className="col-md-6 mb-3">
                        <TextField
                          name="pincode"
                          type="number"
                          //   margin="dense"
                          value={formik.values.pincode}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          placeholder="412216"
                          variant="outlined"
                          label="pincode"
                          fullWidth
                          required
                        ></TextField>
                        <p className="text-danger">{formik.errors.pincode}</p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div>
                          <TextField
                            name="location"
                            type="text"
                            //   margin="dense"
                            value={formik.values.location}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            placeholder="Geo Location"
                            variant="outlined"
                            label="Organization/Institute Geo Location"
                            fullWidth
                            required
                          ></TextField>
                          <p className="text-danger">
                            {formik.errors.location}
                          </p>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div>
                          <TextField
                            name="url1"
                            type="text"
                            //   margin="dense"
                            value={formik.values.url1}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            placeholder="Website Url"
                            variant="outlined"
                            label="Website Url"
                            fullWidth
                            required
                          ></TextField>
                          <p className="text-danger">{formik.errors.url1}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="text-center">
                  <span className="mb-1 d-block">
                    <input type="checkbox" name="" id="" /> &nbsp; All The Above
                    Information is Correct and If It Is Wrong Then I Am
                    Responsible For The Same.
                  </span>
                  <Button
                    className="banner text-white p-1 rounded-2 border-0 w-50"
                    type="submit"
                  >
                    Save
                  </Button>
                </div>
              </form>
            </Modal.Body>
          </Modal>
        </div>

        <div className="container" style={{ overflowX: "scroll" }}>
          <table class="table table-striped border">
            <thead>
              <tr>
                <th>Sr. No.</th>
                <th>Business Name</th>
                <th>Owner</th>
                <th>Contact No.</th>
                <th> Email</th>
                <th>Details</th>

                <th>Address</th>
                <th>Landmark</th>
                <th>City</th>
                <th>Pincode</th>
                <th>Location</th>
                <th>Website URL</th>
                <th>Document</th>
                <th>Edit</th>
                <th>Delete</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => {
                return (
                  <tr key={item.id}>
                    <th scope="row">{index + 1}</th>
                    <td>{item.business_name}</td>
                    <td>{item.owner}</td>
                    <td>{item.mobile}</td>
                    <td>{item.email}</td>
                    <td>{item.details}</td>

                    <td>{item.address}</td>
                    <td>{item.landmark}</td>
                    <td>{item.city}</td>
                    <td>{item.pincode}</td>
                    <td>{item.location}</td>
                    <td>{item.url1}</td>
                    <td>
                      <a
                        className="btn btn-info"
                        href={item.image}
                        target="_blank"
                      >
                        View
                      </a>
                    </td>
                    <td>
                      <div className="btn banner text-white">
                        <AiFillEdit onClick={() => handleShowGallery(item)} />
                      </div>
                    </td>
                    <td>
                      <div className="btn banner text-white">
                        <AiFillDelete onClick={() => handleDelete(item)} />
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default AddOrganizationDetails;
